import { Temporal } from "@imago/api-client"
import { useEffect, useState } from "react"

function roundedNow(roundTo: 'minute' | 'hour') {
	return Temporal.Now.zonedDateTimeISO().round(roundTo).toString()
}

export function useNow(roundTo: 'minute' | 'hour') {
	const [now, setNow] = useState(roundedNow(roundTo))

	useEffect(() => {
		const timer = setInterval(() => {
			setNow(roundedNow(roundTo))
		}, 1000)

		return () => clearInterval(timer)
	}, [])

	return Temporal.ZonedDateTime.from(now)
}
